import { useSelector } from "react-redux";

import { FreshpaintState } from "../reducers";

export default function useUsers() {
  return useSelector((state: FreshpaintState) => state.users);
}
